
import Testimonial from '@/components/blocks/testimonial.vue';
import Link from '@/components/ui/link.vue';
import Slider from '@/components/ui/slider.vue';

export default {
  name: 'Testimonials',

  components: {
    Testimonial,
    Link,
    Slider,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  beforeMount() {
    const placeholder = { id: 'placeholder', isEmpty: true };
    if (this.data.testimonial.length > 1) {
      this.data.testimonial.splice(1, 0, placeholder);
    }
  },
};
